import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {useCurrentUser} from '@netx/core-user-next/store';
import {PermissionName} from '../constants';
import {legacyPermissionsEnabled} from './legacyPermissionsEnabled';

export const currentUserIsAdmin = () => {
	if (legacyPermissionsEnabled())
		return currentUserMeetsUserLevel(UserLevel.ADMIN);
	return useCurrentUser
		.getState()
		.user.appPermissions.includes(PermissionName.IS_ADMIN);
};
